import * as Types from '../../../@types/graphql-types';

import gql from 'graphql-tag';
import { TitleDetailsFragmentDoc } from '../fragments/TitleDetails.fragment';
import { TitleDetailModulesFragmentDoc } from '../fragments/TitleDetailModules.fragment';
export type GetUrlTitleDetailsQueryVariables = Types.Exact<{
	fullPath: Types.Scalars['String']['input'];
	site?: Types.InputMaybe<Types.Scalars['String']['input']>;
	country: Types.Scalars['Country']['input'];
	language: Types.Scalars['Language']['input'];
	episodeMaxLimit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
	platform?: Types.Platform;
	allowSponsoredRecommendations?: Types.InputMaybe<Types.SponsoredRecommendationsInput>;
	format?: Types.InputMaybe<Types.ImageFormat>;
	backdropProfile?: Types.InputMaybe<Types.BackdropProfile>;
	excludeTextRecommendationTitle?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	streamingChartsFilter?: Types.InputMaybe<Types.StreamingChartsFilter>;
	first?: Types.Scalars['Int']['input'];
	fallbackToForeignOffers?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
	excludePackages?: Types.InputMaybe<Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']>;
}>;

export type GetUrlTitleDetailsQuery = {
	__typename?: 'Query';
	urlV2: {
		__typename?: 'Url';
		id: string;
		urlID: number;
		inLists: Array<string>;
		metaDescription?: string | null;
		metaKeywords?: string | null;
		metaRobots?: string | null;
		metaTitle?: string | null;
		heading1?: string | null;
		heading2?: string | null;
		htmlContent?: string | null;
		htmlContentJson?: any | null;
		node:
			| { __typename?: 'Article' }
			| { __typename?: 'Author' }
			| { __typename?: 'Bundle' }
			| { __typename?: 'Device' }
			| { __typename?: 'Episode' }
			| { __typename?: 'GenericTitleList' }
			| { __typename?: 'Genre' }
			| { __typename?: 'HomePage' }
			| {
					__typename: 'Movie';
					totalPackages: number;
					permanentAudiences: Array<string>;
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					maxOfferUpdatedAt?: any | null;
					recommendedByCount: number;
					watchedByCount: number;
					uniqueOfferCount: number;
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{
						__typename?: 'TitleListEntry';
						createdAt: any;
						genericTitleList: { __typename?: 'GenericTitleList'; id: string };
					}>;
					similarTitlesV2: {
						__typename?: 'SimilarTitlesConnection';
						sponsoredAd?: {
							__typename?: 'SponsoredRecommendationAd';
							bidId: string;
							holdoutGroup: boolean;
							campaign?: {
								__typename: 'SponsoredRecommendationCampaign';
								name: string;
								countdownTimer?: any | null;
								creativeType?: Types.CreativeType | null;
								disclaimerText?: string | null;
								hideDetailPageButton: boolean;
								hideImdbScore?: boolean | null;
								hideJwScore?: boolean | null;
								hideRatings: boolean;
								hideContent?: boolean | null;
								posterOverride?: string | null;
								playSRVideoAsGif?: boolean | null;
								promotionalImageUrl?: string | null;
								promotionalTitle?: string | null;
								promotionalText?: string | null;
								promotionalProviderLogo?: string | null;
								promotionalProviderWideLogo?: string | null;
								tags?: Array<string> | null;
								bannerText?: string | null;
								watchNowLabel?: string | null;
								backgroundImages?: Array<{
									__typename?: 'BackgroundImage';
									imageURL: string;
									size: Types.BackgroundImageSize;
								} | null> | null;
								backgroundVideos?: Array<{
									__typename?: 'BackgroundVideo';
									videoURL: string;
									size: Types.BackgroundVideoSize;
								} | null> | null;
								externalTrackers: Array<{
									__typename?: 'ExternalTracker';
									type: Types.ExternalTrackerType;
									data: string;
								}>;
								promotionalVideo?: { __typename?: 'PromotionalVideo'; url: string } | null;
								watchNowOffer: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									mediaDealId?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								};
								nodeOverrides: Array<{
									__typename?: 'NodeOverride';
									nodeId: string;
									promotionalImageUrl?: string | null;
									watchNowOffer?: { __typename?: 'Offer'; standardWebURL?: string | null } | null;
								}>;
								node:
									| { __typename: 'Article'; nodeId: string }
									| { __typename: 'Author'; nodeId: string }
									| { __typename: 'Bundle'; nodeId: string }
									| { __typename: 'Device'; nodeId: string }
									| { __typename: 'Episode'; nodeId: string }
									| {
											__typename: 'GenericTitleList';
											id: string;
											type: Types.GenericTitleListType;
											nodeId: string;
											followedlistEntry?: {
												__typename?: 'FollowedListEntry';
												createdAt: any;
												name: string;
											} | null;
											content: {
												__typename?: 'GenericTitleListContent';
												name: string;
												visibility: Types.GenericTitleListVisibility;
											};
											titles: {
												__typename?: 'GenericTitleListConnection';
												totalCount: number;
												edges?: Array<{
													__typename?: 'GenericTitleListEdge';
													cursor: string;
													node:
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'MovieContent';
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
														  }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	seasonNumber: number;
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
																show: {
																	__typename: 'Show';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																};
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'ShowContent';
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
														  };
												}> | null;
											};
									  }
									| { __typename: 'Genre'; nodeId: string }
									| { __typename: 'HomePage'; nodeId: string }
									| {
											__typename: 'Movie';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'MovieContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												credits: Array<{
													__typename?: 'Credit';
													role: Types.CreditRole;
													name: string;
													characterName?: string | null;
													personId: number;
												}>;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									  }
									| { __typename: 'MultiStepSportEvent'; nodeId: string }
									| { __typename: 'Offer'; nodeId: string }
									| { __typename: 'OfferHistory'; nodeId: string }
									| { __typename: 'Package'; nodeId: string }
									| { __typename: 'Page'; nodeId: string }
									| { __typename: 'Person'; nodeId: string }
									| { __typename: 'PressRelease'; nodeId: string }
									| { __typename: 'ProfileV2'; nodeId: string }
									| {
											__typename: 'Season';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'SeasonContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												seasonNumber: number;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											show: {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: { __typename?: 'ShowContent'; originalTitle: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
									  }
									| {
											__typename: 'Show';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'ShowContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												credits: Array<{
													__typename?: 'Credit';
													role: Types.CreditRole;
													name: string;
													characterName?: string | null;
													personId: number;
												}>;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
									  }
									| { __typename: 'SingleStepSportEvent'; nodeId: string }
									| { __typename: 'SportCompetitionV2'; nodeId: string }
									| { __typename: 'SportCompetitorV2'; nodeId: string }
									| { __typename: 'SportMatch'; nodeId: string }
									| { __typename: 'Url'; nodeId: string }
									| { __typename: 'UserProviderSubscription'; nodeId: string };
							} | null;
						} | null;
					};
					seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					justwatchTVOffers: Array<{
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					}>;
					offersHistory: Array<{
						__typename: 'OfferHistory';
						id: string;
						country: any;
						dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
						package: {
							__typename?: 'Package';
							icon: string;
							id: string;
							iconWide: string;
							clearName: string;
							packageId: number;
							monetizationTypes: Array<Types.MonetizationType>;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					offersDvdBluray: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					bundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedBundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedOffers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'MovieContent';
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
					};
					content: {
						__typename?: 'MovieContent';
						originalTitle: string;
						ageCertification?: string | null;
						productionCountries: Array<any>;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						subgenres: Array<{
							__typename?: 'GenericTitleList';
							content: {
								__typename?: 'GenericTitleListContent';
								shortName?: string | null;
								name: string;
								url?: { __typename?: 'Url'; fullPath: string } | null;
							};
						}>;
						editorialContent?: { __typename?: 'EditorialContent'; synopsis?: string | null } | null;
						directors: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
						credits: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
						interactions: {
							__typename?: 'InteractionAttributes';
							dislikelistAdditions: number;
							likelistAdditions: number;
							votesNumber: number;
						};
						tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null; wikidataId?: string | null };
						externalURLs: { __typename?: 'ExternalURLs'; wikipediaURL?: string | null };
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							releaseType: Types.ReleaseType;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									retailPrice?: string | null;
									durationDays?: number | null;
									presentationType?: Types.PresentationType | null;
									isTrial?: boolean | null;
									retailPriceValue?: number | null;
									currency?: string | null;
								}>;
							} | null;
						}>;
						genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
						textRecommendations?: Array<{
							__typename: 'TextRecommendation';
							id: string;
							headline?: string | null;
							body: string;
							bodyHTML: string;
							originalHeadline?: string | null;
							originalBody?: string | null;
							originalBodyHTML?: string | null;
							watchIf?: Array<string> | null;
							skipIf?: Array<string> | null;
							customProfileType?: string | null;
							watchedAt: any;
							likeCount: number;
							likedByUser: boolean;
							ownedByUser: boolean;
							updatedAt: any;
							tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
							watchedOn?: {
								__typename?: 'Package';
								clearName: string;
								id: string;
								shortName: string;
								technicalName: string;
								packageId: number;
								selected: boolean;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								isVisibleFilterBar: boolean;
								addonParent?: { __typename?: 'Package'; id: string } | null;
							} | null;
							profile: {
								__typename: 'Profile';
								displayName: string;
								firstName: string;
								lastName: string;
								location?: string | null;
								country: any;
								bio?: string | null;
								avatarUrl?: string | null;
								isComplete: boolean;
								ownedByUser: boolean;
								profileUrl: string;
								profileType: Types.ProfileType;
								contentPersonId?: string | null;
								textRecommendationsCount: number;
								id: string;
								externalUrls?: Array<{
									__typename?: 'ProfileSpecificLink';
									type: Types.ProfileSpecificLinkType;
									name?: string | null;
									url: string;
								}> | null;
							};
							title?:
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'MovieContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										show: {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											content: { __typename?: 'ShowContent'; title: string; fullPath: string };
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												mediaDealId?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											seenState: { __typename?: 'ShowSeenState'; progress: number };
											tvShowTrackingEntry?: {
												__typename?: 'TitleListEntry';
												createdAt: any;
											} | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'ShowContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  };
							video?: {
								__typename?: 'Clip';
								externalId: string;
								name: string;
								provider: Types.ClipProvider;
								publishedAt: any;
								sourceUrl: string;
								streamUrl?: string | null;
							} | null;
						}> | null;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					streamingCharts: {
						__typename?: 'StreamingChartsConnection';
						edges?: Array<{
							__typename?: 'StreamingChartsTitlesEdge';
							streamingChartInfo?: {
								__typename?: 'StreamingChartInfo';
								rank: number;
								trend: Types.ModuleContentTitleTrend;
								trendDifference: number;
								updatedAt?: any | null;
								daysInTop10: number;
								daysInTop100: number;
								daysInTop1000: number;
								daysInTop3: number;
								topRank: number;
							} | null;
						}> | null;
					};
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					titleModules: Array<{
						__typename?: 'Module';
						fomoScore: number;
						content?:
							| { __typename?: 'ModuleContentSQTV' }
							| { __typename?: 'ModuleContentSports' }
							| {
									__typename?: 'ModuleContentStreamingCharts';
									Titles: Array<{
										__typename?: 'ModuleStreamingChartEdges';
										fullPath: string;
										jwEntityID: string;
										posterUrl: string;
										title: string;
										showTitle?: string | null;
										seasonNumber?: number | null;
										rankInfo: {
											__typename?: 'StreamingChartInfo';
											rank: number;
											trend: Types.ModuleContentTitleTrend;
											trendDifference: number;
											updatedAt?: any | null;
											daysInTop10: number;
											daysInTop100: number;
											daysInTop1000: number;
											daysInTop3: number;
											topRank: number;
										};
									}>;
							  }
							| { __typename?: 'ModuleContentTextRecommendation' }
							| { __typename?: 'ModuleContentTextRecommendations' }
							| {
									__typename?: 'ModuleContentTitles';
									titles: Array<{
										__typename?: 'ModuleContentTitleEdge';
										node:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
													show: {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: { __typename?: 'ShowContent'; title: string };
													};
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenState: {
														__typename?: 'ShowSeenState';
														progress: number;
														seenEpisodeCount: number;
													};
													content: {
														__typename?: 'ShowContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  };
									}>;
							  }
							| { __typename?: 'ModuleContentTitlesArticle' }
							| { __typename?: 'ModuleContentTitlesPerPackage' }
							| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
							| { __typename?: 'ModuleContentVODTitles' }
							| null;
						template: {
							__typename?: 'ModuleTemplate';
							anchor?: string | null;
							contentType: Types.ModuleContentType;
							technicalName: string;
						};
					} | null>;
			  }
			| { __typename?: 'MultiStepSportEvent' }
			| { __typename?: 'Offer' }
			| { __typename?: 'OfferHistory' }
			| { __typename?: 'Package' }
			| { __typename?: 'Page' }
			| { __typename?: 'Person' }
			| { __typename?: 'PressRelease' }
			| { __typename?: 'ProfileV2' }
			| {
					__typename: 'Season';
					totalEpisodeCount: number;
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					maxOfferUpdatedAt?: any | null;
					recommendedByCount: number;
					watchedByCount: number;
					uniqueOfferCount: number;
					episodes: Array<{
						__typename?: 'Episode';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						uniqueOfferCount: number;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						flatrate: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						buy: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						rent: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						free: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						fast: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						content: {
							__typename: 'EpisodeContent';
							title: string;
							shortDescription?: string | null;
							episodeNumber: number;
							seasonNumber: number;
							isReleased: boolean;
							runtime?: number | null;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseCountDown?: number | null;
								releaseDate?: any | null;
								releaseType: Types.ReleaseType;
								label: Types.UpcomingReleaseLabel;
								package?: {
									__typename?: 'Package';
									id: string;
									packageId: number;
									shortName: string;
									clearName: string;
									monetizationTypes: Array<Types.MonetizationType>;
									icon: string;
									iconWide: string;
									hasRectangularIcon: boolean;
									planOffers: Array<{
										__typename?: 'PackagePlanOffer';
										retailPrice?: string | null;
										durationDays?: number | null;
										presentationType?: Types.PresentationType | null;
										isTrial?: boolean | null;
										retailPriceValue?: number | null;
										currency?: string | null;
									}>;
								} | null;
							}>;
						};
					}>;
					show: {
						__typename: 'Show';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						totalSeasonCount: number;
						customlistEntries: Array<{
							__typename?: 'TitleListEntry';
							createdAt: any;
							genericTitleList: { __typename?: 'GenericTitleList'; id: string };
						}>;
						tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						fallBackClips: {
							__typename?: 'ShowContent';
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							justwatchtvClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
						};
						content: {
							__typename?: 'ShowContent';
							title: string;
							ageCertification?: string | null;
							fullPath: string;
							productionCountries: Array<any>;
							posterUrl?: string | null;
							isReleased: boolean;
							genres: Array<{ __typename?: 'Genre'; shortName: string }>;
							subgenres: Array<{
								__typename?: 'GenericTitleList';
								content: {
									__typename?: 'GenericTitleListContent';
									shortName?: string | null;
									name: string;
								};
							}>;
							directors: Array<{
								__typename: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
								portraitUrl?: string | null;
								profilePath?: string | null;
							}>;
							credits: Array<{
								__typename: 'Credit';
								role: Types.CreditRole;
								name: string;
								characterName?: string | null;
								personId: number;
								portraitUrl?: string | null;
								profilePath?: string | null;
							}>;
							externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseType: Types.ReleaseType;
								package?: {
									__typename?: 'Package';
									id: string;
									shortName: string;
									planOffers: Array<{
										__typename?: 'PackagePlanOffer';
										retailPrice?: string | null;
										durationDays?: number | null;
										presentationType?: Types.PresentationType | null;
										isTrial?: boolean | null;
										retailPriceValue?: number | null;
										currency?: string | null;
									}>;
								} | null;
							}>;
							backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							justwatchtvClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
						};
						seenState: { __typename?: 'ShowSeenState'; progress: number };
						watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						similarTitlesV2: {
							__typename?: 'SimilarTitlesConnection';
							sponsoredAd?: {
								__typename?: 'SponsoredRecommendationAd';
								bidId: string;
								holdoutGroup: boolean;
								campaign?: {
									__typename: 'SponsoredRecommendationCampaign';
									name: string;
									countdownTimer?: any | null;
									creativeType?: Types.CreativeType | null;
									disclaimerText?: string | null;
									hideDetailPageButton: boolean;
									hideImdbScore?: boolean | null;
									hideJwScore?: boolean | null;
									hideRatings: boolean;
									hideContent?: boolean | null;
									posterOverride?: string | null;
									playSRVideoAsGif?: boolean | null;
									promotionalImageUrl?: string | null;
									promotionalTitle?: string | null;
									promotionalText?: string | null;
									promotionalProviderLogo?: string | null;
									promotionalProviderWideLogo?: string | null;
									tags?: Array<string> | null;
									bannerText?: string | null;
									watchNowLabel?: string | null;
									backgroundImages?: Array<{
										__typename?: 'BackgroundImage';
										imageURL: string;
										size: Types.BackgroundImageSize;
									} | null> | null;
									backgroundVideos?: Array<{
										__typename?: 'BackgroundVideo';
										videoURL: string;
										size: Types.BackgroundVideoSize;
									} | null> | null;
									externalTrackers: Array<{
										__typename?: 'ExternalTracker';
										type: Types.ExternalTrackerType;
										data: string;
									}>;
									promotionalVideo?: { __typename?: 'PromotionalVideo'; url: string } | null;
									watchNowOffer: {
										__typename: 'Offer';
										id: string;
										standardWebURL?: string | null;
										preAffiliatedStandardWebURL?: string | null;
										streamUrl?: string | null;
										streamUrlExternalPlayer?: string | null;
										retailPrice?: string | null;
										retailPriceValue?: number | null;
										lastChangeRetailPriceValue?: number | null;
										currency?: string | null;
										presentationType: Types.PresentationType;
										monetizationType: Types.MonetizationType;
										availableTo?: any | null;
										dateCreated?: any | null;
										newElementCount?: number | null;
										mediaDealId?: number | null;
										package: {
											__typename?: 'Package';
											id: string;
											icon: string;
											packageId: number;
											clearName: string;
											shortName: string;
											technicalName: string;
											iconWide: string;
											hasRectangularIcon: boolean;
										};
									};
									nodeOverrides: Array<{
										__typename?: 'NodeOverride';
										nodeId: string;
										promotionalImageUrl?: string | null;
										watchNowOffer?: { __typename?: 'Offer'; standardWebURL?: string | null } | null;
									}>;
									node:
										| { __typename: 'Article'; nodeId: string }
										| { __typename: 'Author'; nodeId: string }
										| { __typename: 'Bundle'; nodeId: string }
										| { __typename: 'Device'; nodeId: string }
										| { __typename: 'Episode'; nodeId: string }
										| {
												__typename: 'GenericTitleList';
												id: string;
												type: Types.GenericTitleListType;
												nodeId: string;
												followedlistEntry?: {
													__typename?: 'FollowedListEntry';
													createdAt: any;
													name: string;
												} | null;
												content: {
													__typename?: 'GenericTitleListContent';
													name: string;
													visibility: Types.GenericTitleListVisibility;
												};
												titles: {
													__typename?: 'GenericTitleListConnection';
													totalCount: number;
													edges?: Array<{
														__typename?: 'GenericTitleListEdge';
														cursor: string;
														node:
															| {
																	__typename: 'Movie';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	content: {
																		__typename?: 'MovieContent';
																		fullPath: string;
																		posterUrl?: string | null;
																		title: string;
																		originalReleaseYear?: number | null;
																		isReleased: boolean;
																		credits: Array<{
																			__typename?: 'Credit';
																			role: Types.CreditRole;
																			name: string;
																			characterName?: string | null;
																			personId: number;
																		}>;
																		interactions: {
																			__typename?: 'InteractionAttributes';
																			dislikelistAdditions: number;
																			likelistAdditions: number;
																			votesNumber: number;
																		};
																		scoring: {
																			__typename?: 'Scoring';
																			imdbVotes?: number | null;
																			imdbScore?: number | null;
																			tomatoMeter?: number | null;
																			certifiedFresh?: boolean | null;
																			jwRating?: number | null;
																		};
																	};
															  }
															| {
																	__typename: 'Season';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	content: {
																		__typename?: 'SeasonContent';
																		seasonNumber: number;
																		fullPath: string;
																		posterUrl?: string | null;
																		title: string;
																		originalReleaseYear?: number | null;
																		isReleased: boolean;
																		interactions: {
																			__typename?: 'InteractionAttributes';
																			dislikelistAdditions: number;
																			likelistAdditions: number;
																			votesNumber: number;
																		};
																		scoring: {
																			__typename?: 'Scoring';
																			imdbVotes?: number | null;
																			imdbScore?: number | null;
																			tomatoMeter?: number | null;
																			certifiedFresh?: boolean | null;
																			jwRating?: number | null;
																		};
																	};
																	show: {
																		__typename: 'Show';
																		id: string;
																		objectId: number;
																		objectType: Types.ObjectType;
																	};
															  }
															| {
																	__typename: 'Show';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																	content: {
																		__typename?: 'ShowContent';
																		fullPath: string;
																		posterUrl?: string | null;
																		title: string;
																		originalReleaseYear?: number | null;
																		isReleased: boolean;
																		credits: Array<{
																			__typename?: 'Credit';
																			role: Types.CreditRole;
																			name: string;
																			characterName?: string | null;
																			personId: number;
																		}>;
																		interactions: {
																			__typename?: 'InteractionAttributes';
																			dislikelistAdditions: number;
																			likelistAdditions: number;
																			votesNumber: number;
																		};
																		scoring: {
																			__typename?: 'Scoring';
																			imdbVotes?: number | null;
																			imdbScore?: number | null;
																			tomatoMeter?: number | null;
																			certifiedFresh?: boolean | null;
																			jwRating?: number | null;
																		};
																	};
															  };
													}> | null;
												};
										  }
										| { __typename: 'Genre'; nodeId: string }
										| { __typename: 'HomePage'; nodeId: string }
										| {
												__typename: 'Movie';
												objectId: number;
												objectType: Types.ObjectType;
												nodeId: string;
												content: {
													__typename?: 'MovieContent';
													fullPath: string;
													posterUrl?: string | null;
													title: string;
													originalReleaseYear?: number | null;
													isReleased: boolean;
													credits: Array<{
														__typename?: 'Credit';
														role: Types.CreditRole;
														name: string;
														characterName?: string | null;
														personId: number;
													}>;
													interactions: {
														__typename?: 'InteractionAttributes';
														dislikelistAdditions: number;
														likelistAdditions: number;
														votesNumber: number;
													};
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														jwRating?: number | null;
													};
													genres: Array<{
														__typename?: 'Genre';
														shortName: string;
														translation: string;
													}>;
													externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												offers: Array<{
													__typename?: 'Offer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													id: string;
													package: { __typename?: 'Package'; id: string; packageId: number };
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
										  }
										| { __typename: 'MultiStepSportEvent'; nodeId: string }
										| { __typename: 'Offer'; nodeId: string }
										| { __typename: 'OfferHistory'; nodeId: string }
										| { __typename: 'Package'; nodeId: string }
										| { __typename: 'Page'; nodeId: string }
										| { __typename: 'Person'; nodeId: string }
										| { __typename: 'PressRelease'; nodeId: string }
										| { __typename: 'ProfileV2'; nodeId: string }
										| {
												__typename: 'Season';
												objectId: number;
												objectType: Types.ObjectType;
												nodeId: string;
												content: {
													__typename?: 'SeasonContent';
													fullPath: string;
													posterUrl?: string | null;
													title: string;
													originalReleaseYear?: number | null;
													isReleased: boolean;
													seasonNumber: number;
													interactions: {
														__typename?: 'InteractionAttributes';
														dislikelistAdditions: number;
														likelistAdditions: number;
														votesNumber: number;
													};
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														jwRating?: number | null;
													};
													genres: Array<{
														__typename?: 'Genre';
														shortName: string;
														translation: string;
													}>;
													externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												offers: Array<{
													__typename?: 'Offer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													id: string;
													package: { __typename?: 'Package'; id: string; packageId: number };
												}>;
												show: {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: { __typename?: 'ShowContent'; originalTitle: string };
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
												};
										  }
										| {
												__typename: 'Show';
												objectId: number;
												objectType: Types.ObjectType;
												nodeId: string;
												content: {
													__typename?: 'ShowContent';
													fullPath: string;
													posterUrl?: string | null;
													title: string;
													originalReleaseYear?: number | null;
													isReleased: boolean;
													credits: Array<{
														__typename?: 'Credit';
														role: Types.CreditRole;
														name: string;
														characterName?: string | null;
														personId: number;
													}>;
													interactions: {
														__typename?: 'InteractionAttributes';
														dislikelistAdditions: number;
														likelistAdditions: number;
														votesNumber: number;
													};
													scoring: {
														__typename?: 'Scoring';
														imdbScore?: number | null;
														jwRating?: number | null;
													};
													genres: Array<{
														__typename?: 'Genre';
														shortName: string;
														translation: string;
													}>;
													externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
													backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
												};
												offers: Array<{
													__typename?: 'Offer';
													monetizationType: Types.MonetizationType;
													presentationType: Types.PresentationType;
													id: string;
													package: { __typename?: 'Package'; id: string; packageId: number };
												}>;
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
												seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
										  }
										| { __typename: 'SingleStepSportEvent'; nodeId: string }
										| { __typename: 'SportCompetitionV2'; nodeId: string }
										| { __typename: 'SportCompetitorV2'; nodeId: string }
										| { __typename: 'SportMatch'; nodeId: string }
										| { __typename: 'Url'; nodeId: string }
										| { __typename: 'UserProviderSubscription'; nodeId: string };
								} | null;
							} | null;
						};
					};
					seenState: { __typename?: 'ShowSeenState'; progress: number };
					justwatchTVOffers: Array<{
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					}>;
					offersHistory: Array<{
						__typename: 'OfferHistory';
						id: string;
						country: any;
						dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
						package: {
							__typename?: 'Package';
							icon: string;
							id: string;
							iconWide: string;
							clearName: string;
							packageId: number;
							monetizationTypes: Array<Types.MonetizationType>;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					offersDvdBluray: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					bundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedBundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedOffers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'SeasonContent';
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
					};
					content: {
						__typename?: 'SeasonContent';
						seasonNumber: number;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						subgenres: Array<{
							__typename?: 'GenericTitleList';
							content: {
								__typename?: 'GenericTitleListContent';
								shortName?: string | null;
								name: string;
								url?: { __typename?: 'Url'; fullPath: string } | null;
							};
						}>;
						editorialContent?: { __typename?: 'EditorialContent'; synopsis?: string | null } | null;
						interactions: {
							__typename?: 'InteractionAttributes';
							dislikelistAdditions: number;
							likelistAdditions: number;
							votesNumber: number;
						};
						tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null; wikidataId?: string | null };
						externalURLs: { __typename?: 'ExternalURLs'; wikipediaURL?: string | null };
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							releaseType: Types.ReleaseType;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									retailPrice?: string | null;
									durationDays?: number | null;
									presentationType?: Types.PresentationType | null;
									isTrial?: boolean | null;
									retailPriceValue?: number | null;
									currency?: string | null;
								}>;
							} | null;
						}>;
						genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
						textRecommendations?: Array<{
							__typename: 'TextRecommendation';
							id: string;
							headline?: string | null;
							body: string;
							bodyHTML: string;
							originalHeadline?: string | null;
							originalBody?: string | null;
							originalBodyHTML?: string | null;
							watchIf?: Array<string> | null;
							skipIf?: Array<string> | null;
							customProfileType?: string | null;
							watchedAt: any;
							likeCount: number;
							likedByUser: boolean;
							ownedByUser: boolean;
							updatedAt: any;
							tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
							watchedOn?: {
								__typename?: 'Package';
								clearName: string;
								id: string;
								shortName: string;
								technicalName: string;
								packageId: number;
								selected: boolean;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								isVisibleFilterBar: boolean;
								addonParent?: { __typename?: 'Package'; id: string } | null;
							} | null;
							profile: {
								__typename: 'Profile';
								displayName: string;
								firstName: string;
								lastName: string;
								location?: string | null;
								country: any;
								bio?: string | null;
								avatarUrl?: string | null;
								isComplete: boolean;
								ownedByUser: boolean;
								profileUrl: string;
								profileType: Types.ProfileType;
								contentPersonId?: string | null;
								textRecommendationsCount: number;
								id: string;
								externalUrls?: Array<{
									__typename?: 'ProfileSpecificLink';
									type: Types.ProfileSpecificLinkType;
									name?: string | null;
									url: string;
								}> | null;
							};
							title?:
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'MovieContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										show: {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											content: { __typename?: 'ShowContent'; title: string; fullPath: string };
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												mediaDealId?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											seenState: { __typename?: 'ShowSeenState'; progress: number };
											tvShowTrackingEntry?: {
												__typename?: 'TitleListEntry';
												createdAt: any;
											} | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'ShowContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  };
							video?: {
								__typename?: 'Clip';
								externalId: string;
								name: string;
								provider: Types.ClipProvider;
								publishedAt: any;
								sourceUrl: string;
								streamUrl?: string | null;
							} | null;
						}> | null;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					streamingCharts: {
						__typename?: 'StreamingChartsConnection';
						edges?: Array<{
							__typename?: 'StreamingChartsTitlesEdge';
							streamingChartInfo?: {
								__typename?: 'StreamingChartInfo';
								rank: number;
								trend: Types.ModuleContentTitleTrend;
								trendDifference: number;
								updatedAt?: any | null;
								daysInTop10: number;
								daysInTop100: number;
								daysInTop1000: number;
								daysInTop3: number;
								topRank: number;
							} | null;
						}> | null;
					};
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					titleModules: Array<{
						__typename?: 'Module';
						fomoScore: number;
						content?:
							| { __typename?: 'ModuleContentSQTV' }
							| { __typename?: 'ModuleContentSports' }
							| {
									__typename?: 'ModuleContentStreamingCharts';
									Titles: Array<{
										__typename?: 'ModuleStreamingChartEdges';
										fullPath: string;
										jwEntityID: string;
										posterUrl: string;
										title: string;
										showTitle?: string | null;
										seasonNumber?: number | null;
										rankInfo: {
											__typename?: 'StreamingChartInfo';
											rank: number;
											trend: Types.ModuleContentTitleTrend;
											trendDifference: number;
											updatedAt?: any | null;
											daysInTop10: number;
											daysInTop100: number;
											daysInTop1000: number;
											daysInTop3: number;
											topRank: number;
										};
									}>;
							  }
							| { __typename?: 'ModuleContentTextRecommendation' }
							| { __typename?: 'ModuleContentTextRecommendations' }
							| {
									__typename?: 'ModuleContentTitles';
									titles: Array<{
										__typename?: 'ModuleContentTitleEdge';
										node:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
													show: {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: { __typename?: 'ShowContent'; title: string };
													};
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenState: {
														__typename?: 'ShowSeenState';
														progress: number;
														seenEpisodeCount: number;
													};
													content: {
														__typename?: 'ShowContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  };
									}>;
							  }
							| { __typename?: 'ModuleContentTitlesArticle' }
							| { __typename?: 'ModuleContentTitlesPerPackage' }
							| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
							| { __typename?: 'ModuleContentVODTitles' }
							| null;
						template: {
							__typename?: 'ModuleTemplate';
							anchor?: string | null;
							contentType: Types.ModuleContentType;
							technicalName: string;
						};
					} | null>;
			  }
			| {
					__typename: 'Show';
					totalPackages: number;
					permanentAudiences: Array<string>;
					totalSeasonCount: number;
					id: string;
					objectType: Types.ObjectType;
					objectId: number;
					offerCount: number;
					maxOfferUpdatedAt?: any | null;
					recommendedByCount: number;
					watchedByCount: number;
					uniqueOfferCount: number;
					watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					customlistEntries: Array<{
						__typename?: 'TitleListEntry';
						createdAt: any;
						genericTitleList: { __typename?: 'GenericTitleList'; id: string };
					}>;
					similarTitlesV2: {
						__typename?: 'SimilarTitlesConnection';
						sponsoredAd?: {
							__typename?: 'SponsoredRecommendationAd';
							bidId: string;
							holdoutGroup: boolean;
							campaign?: {
								__typename: 'SponsoredRecommendationCampaign';
								name: string;
								countdownTimer?: any | null;
								creativeType?: Types.CreativeType | null;
								disclaimerText?: string | null;
								hideDetailPageButton: boolean;
								hideImdbScore?: boolean | null;
								hideJwScore?: boolean | null;
								hideRatings: boolean;
								hideContent?: boolean | null;
								posterOverride?: string | null;
								playSRVideoAsGif?: boolean | null;
								promotionalImageUrl?: string | null;
								promotionalTitle?: string | null;
								promotionalText?: string | null;
								promotionalProviderLogo?: string | null;
								promotionalProviderWideLogo?: string | null;
								tags?: Array<string> | null;
								bannerText?: string | null;
								watchNowLabel?: string | null;
								backgroundImages?: Array<{
									__typename?: 'BackgroundImage';
									imageURL: string;
									size: Types.BackgroundImageSize;
								} | null> | null;
								backgroundVideos?: Array<{
									__typename?: 'BackgroundVideo';
									videoURL: string;
									size: Types.BackgroundVideoSize;
								} | null> | null;
								externalTrackers: Array<{
									__typename?: 'ExternalTracker';
									type: Types.ExternalTrackerType;
									data: string;
								}>;
								promotionalVideo?: { __typename?: 'PromotionalVideo'; url: string } | null;
								watchNowOffer: {
									__typename: 'Offer';
									id: string;
									standardWebURL?: string | null;
									preAffiliatedStandardWebURL?: string | null;
									streamUrl?: string | null;
									streamUrlExternalPlayer?: string | null;
									retailPrice?: string | null;
									retailPriceValue?: number | null;
									lastChangeRetailPriceValue?: number | null;
									currency?: string | null;
									presentationType: Types.PresentationType;
									monetizationType: Types.MonetizationType;
									availableTo?: any | null;
									dateCreated?: any | null;
									newElementCount?: number | null;
									mediaDealId?: number | null;
									package: {
										__typename?: 'Package';
										id: string;
										icon: string;
										packageId: number;
										clearName: string;
										shortName: string;
										technicalName: string;
										iconWide: string;
										hasRectangularIcon: boolean;
									};
								};
								nodeOverrides: Array<{
									__typename?: 'NodeOverride';
									nodeId: string;
									promotionalImageUrl?: string | null;
									watchNowOffer?: { __typename?: 'Offer'; standardWebURL?: string | null } | null;
								}>;
								node:
									| { __typename: 'Article'; nodeId: string }
									| { __typename: 'Author'; nodeId: string }
									| { __typename: 'Bundle'; nodeId: string }
									| { __typename: 'Device'; nodeId: string }
									| { __typename: 'Episode'; nodeId: string }
									| {
											__typename: 'GenericTitleList';
											id: string;
											type: Types.GenericTitleListType;
											nodeId: string;
											followedlistEntry?: {
												__typename?: 'FollowedListEntry';
												createdAt: any;
												name: string;
											} | null;
											content: {
												__typename?: 'GenericTitleListContent';
												name: string;
												visibility: Types.GenericTitleListVisibility;
											};
											titles: {
												__typename?: 'GenericTitleListConnection';
												totalCount: number;
												edges?: Array<{
													__typename?: 'GenericTitleListEdge';
													cursor: string;
													node:
														| {
																__typename: 'Movie';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'MovieContent';
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
														  }
														| {
																__typename: 'Season';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'SeasonContent';
																	seasonNumber: number;
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
																show: {
																	__typename: 'Show';
																	id: string;
																	objectId: number;
																	objectType: Types.ObjectType;
																};
														  }
														| {
																__typename: 'Show';
																id: string;
																objectId: number;
																objectType: Types.ObjectType;
																content: {
																	__typename?: 'ShowContent';
																	fullPath: string;
																	posterUrl?: string | null;
																	title: string;
																	originalReleaseYear?: number | null;
																	isReleased: boolean;
																	credits: Array<{
																		__typename?: 'Credit';
																		role: Types.CreditRole;
																		name: string;
																		characterName?: string | null;
																		personId: number;
																	}>;
																	interactions: {
																		__typename?: 'InteractionAttributes';
																		dislikelistAdditions: number;
																		likelistAdditions: number;
																		votesNumber: number;
																	};
																	scoring: {
																		__typename?: 'Scoring';
																		imdbVotes?: number | null;
																		imdbScore?: number | null;
																		tomatoMeter?: number | null;
																		certifiedFresh?: boolean | null;
																		jwRating?: number | null;
																	};
																};
														  };
												}> | null;
											};
									  }
									| { __typename: 'Genre'; nodeId: string }
									| { __typename: 'HomePage'; nodeId: string }
									| {
											__typename: 'Movie';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'MovieContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												credits: Array<{
													__typename?: 'Credit';
													role: Types.CreditRole;
													name: string;
													characterName?: string | null;
													personId: number;
												}>;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
									  }
									| { __typename: 'MultiStepSportEvent'; nodeId: string }
									| { __typename: 'Offer'; nodeId: string }
									| { __typename: 'OfferHistory'; nodeId: string }
									| { __typename: 'Package'; nodeId: string }
									| { __typename: 'Page'; nodeId: string }
									| { __typename: 'Person'; nodeId: string }
									| { __typename: 'PressRelease'; nodeId: string }
									| { __typename: 'ProfileV2'; nodeId: string }
									| {
											__typename: 'Season';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'SeasonContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												seasonNumber: number;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											show: {
												__typename: 'Show';
												id: string;
												objectId: number;
												objectType: Types.ObjectType;
												content: { __typename?: 'ShowContent'; originalTitle: string };
												watchlistEntryV2?: {
													__typename?: 'TitleListEntry';
													createdAt: any;
												} | null;
											};
									  }
									| {
											__typename: 'Show';
											objectId: number;
											objectType: Types.ObjectType;
											nodeId: string;
											content: {
												__typename?: 'ShowContent';
												fullPath: string;
												posterUrl?: string | null;
												title: string;
												originalReleaseYear?: number | null;
												isReleased: boolean;
												credits: Array<{
													__typename?: 'Credit';
													role: Types.CreditRole;
													name: string;
													characterName?: string | null;
													personId: number;
												}>;
												interactions: {
													__typename?: 'InteractionAttributes';
													dislikelistAdditions: number;
													likelistAdditions: number;
													votesNumber: number;
												};
												scoring: {
													__typename?: 'Scoring';
													imdbScore?: number | null;
													jwRating?: number | null;
												};
												genres: Array<{
													__typename?: 'Genre';
													shortName: string;
													translation: string;
												}>;
												externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null };
												backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
											};
											offers: Array<{
												__typename?: 'Offer';
												monetizationType: Types.MonetizationType;
												presentationType: Types.PresentationType;
												id: string;
												package: { __typename?: 'Package'; id: string; packageId: number };
											}>;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											seenState: { __typename?: 'ShowSeenState'; seenEpisodeCount: number };
									  }
									| { __typename: 'SingleStepSportEvent'; nodeId: string }
									| { __typename: 'SportCompetitionV2'; nodeId: string }
									| { __typename: 'SportCompetitorV2'; nodeId: string }
									| { __typename: 'SportMatch'; nodeId: string }
									| { __typename: 'Url'; nodeId: string }
									| { __typename: 'UserProviderSubscription'; nodeId: string };
							} | null;
						} | null;
					};
					seenState: { __typename?: 'ShowSeenState'; progress: number; seenEpisodeCount: number };
					tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					firstSeason: Array<{
						__typename?: 'Season';
						id: string;
						offers: Array<{
							__typename: 'Offer';
							monetizationType: Types.MonetizationType;
							presentationType: Types.PresentationType;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							package: { __typename: 'Package'; clearName: string; shortName: string };
						}>;
					}>;
					seasons: Array<{
						__typename?: 'Season';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						totalEpisodeCount: number;
						availableTo: Array<{
							__typename?: 'AvailableTo';
							availableToDate: any;
							availableCountDown: number;
							package: { __typename?: 'Package'; id: string; shortName: string };
						}>;
						content: {
							__typename?: 'SeasonContent';
							posterUrl?: string | null;
							seasonNumber: number;
							fullPath: string;
							title: string;
							isReleased: boolean;
							originalReleaseYear?: number | null;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseDate?: any | null;
								releaseCountDown?: number | null;
							}>;
						};
						show: {
							__typename: 'Show';
							id: string;
							objectId: number;
							objectType: Types.ObjectType;
							watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
							content: { __typename?: 'ShowContent'; title: string };
						};
						fallBackClips: {
							__typename?: 'SeasonContent';
							clips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							videobusterClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							dailymotionClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
							justwatchtvClips: Array<{
								__typename?: 'Clip';
								sourceUrl: string;
								externalId: string;
								provider: Types.ClipProvider;
								name: string;
								sources: {
									__typename?: 'Sources';
									dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
								};
							}>;
						};
					}>;
					recentEpisodes: Array<{
						__typename?: 'Episode';
						id: string;
						objectId: number;
						objectType: Types.ObjectType;
						uniqueOfferCount: number;
						seenlistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
						flatrate: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						buy: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						rent: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						free: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						fast: Array<{
							__typename?: 'Offer';
							id: string;
							package: { __typename?: 'Package'; id: string; clearName: string; packageId: number };
						}>;
						content: {
							__typename: 'EpisodeContent';
							title: string;
							shortDescription?: string | null;
							episodeNumber: number;
							seasonNumber: number;
							isReleased: boolean;
							runtime?: number | null;
							upcomingReleases: Array<{
								__typename?: 'UpcomingRelease';
								releaseCountDown?: number | null;
								releaseDate?: any | null;
								releaseType: Types.ReleaseType;
								label: Types.UpcomingReleaseLabel;
								package?: {
									__typename?: 'Package';
									id: string;
									packageId: number;
									shortName: string;
									clearName: string;
									monetizationTypes: Array<Types.MonetizationType>;
									icon: string;
									iconWide: string;
									hasRectangularIcon: boolean;
									planOffers: Array<{
										__typename?: 'PackagePlanOffer';
										retailPrice?: string | null;
										durationDays?: number | null;
										presentationType?: Types.PresentationType | null;
										isTrial?: boolean | null;
										retailPriceValue?: number | null;
										currency?: string | null;
									}>;
								} | null;
							}>;
						};
					}>;
					justwatchTVOffers: Array<{
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					}>;
					offersHistory: Array<{
						__typename: 'OfferHistory';
						id: string;
						country: any;
						dateRanges: Array<{ __typename?: 'DateRange'; end: any; start: any }>;
						package: {
							__typename?: 'Package';
							icon: string;
							id: string;
							iconWide: string;
							clearName: string;
							packageId: number;
							monetizationTypes: Array<Types.MonetizationType>;
						};
					}>;
					offers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					offersDvdBluray: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					bundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedBundles: Array<{
						__typename?: 'PromotedBundleEdge';
						promotionUrl: string;
						node: {
							__typename?: 'Bundle';
							id: string;
							clearName: string;
							icon: string;
							technicalName: string;
							bundleId: number;
							shortName: string;
							packages: Array<{
								__typename?: 'Package';
								icon: string;
								id: string;
								clearName: string;
								packageId: number;
								iconWide: string;
								shortName: string;
							}>;
						};
						offer: {
							__typename?: 'Offer';
							id: string;
							presentationType: Types.PresentationType;
							monetizationType: Types.MonetizationType;
							newElementCount?: number | null;
							retailPrice?: string | null;
							retailPriceValue?: number | null;
							userLocalCurrency?: string | null;
							retailPriceConverted?: string | null;
							currency?: string | null;
							lastChangeRetailPriceValue?: number | null;
							type: Types.OfferType;
							country: any;
							standardWebURL?: string | null;
							preAffiliatedStandardWebURL?: string | null;
							streamUrl?: string | null;
							streamUrlExternalPlayer?: string | null;
							elementCount?: number | null;
							availableTo?: any | null;
							subtitleLanguages: Array<any>;
							videoTechnology: Array<Types.VideoTechnology>;
							audioTechnology: Array<Types.AudioTechnology>;
							audioLanguages: Array<any>;
							updatedAt?: any | null;
							mediaDealId?: number | null;
							package: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								clearName: string;
								shortName: string;
								technicalName: string;
								icon: string;
								iconWide: string;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
									retailPriceConverted?: string | null;
									children: Array<{
										__typename?: 'PackagePlanOffer';
										title?: string | null;
										retailPrice?: string | null;
										isTrial?: boolean | null;
										durationDays?: number | null;
										retailPriceValue?: number | null;
									}>;
								}>;
							};
							plans: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
					}>;
					promotedOffers: Array<{
						__typename?: 'Offer';
						offerSeasons?: Array<string> | null;
						minRetailPrice?: string | null;
						id: string;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						newElementCount?: number | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						userLocalCurrency?: string | null;
						retailPriceConverted?: string | null;
						currency?: string | null;
						lastChangeRetailPriceValue?: number | null;
						type: Types.OfferType;
						country: any;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						elementCount?: number | null;
						availableTo?: any | null;
						subtitleLanguages: Array<any>;
						videoTechnology: Array<Types.VideoTechnology>;
						audioTechnology: Array<Types.AudioTechnology>;
						audioLanguages: Array<any>;
						updatedAt?: any | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							icon: string;
							iconWide: string;
							planOffers: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
								retailPriceConverted?: string | null;
								children: Array<{
									__typename?: 'PackagePlanOffer';
									title?: string | null;
									retailPrice?: string | null;
									isTrial?: boolean | null;
									durationDays?: number | null;
									retailPriceValue?: number | null;
								}>;
							}>;
						};
						plans: Array<{
							__typename?: 'PackagePlanOffer';
							title?: string | null;
							retailPrice?: string | null;
							isTrial?: boolean | null;
							durationDays?: number | null;
							retailPriceValue?: number | null;
							retailPriceConverted?: string | null;
							children: Array<{
								__typename?: 'PackagePlanOffer';
								title?: string | null;
								retailPrice?: string | null;
								isTrial?: boolean | null;
								durationDays?: number | null;
								retailPriceValue?: number | null;
							}>;
						}>;
					}>;
					watchNowOffer?: {
						__typename: 'Offer';
						id: string;
						standardWebURL?: string | null;
						preAffiliatedStandardWebURL?: string | null;
						streamUrl?: string | null;
						streamUrlExternalPlayer?: string | null;
						retailPrice?: string | null;
						retailPriceValue?: number | null;
						lastChangeRetailPriceValue?: number | null;
						currency?: string | null;
						presentationType: Types.PresentationType;
						monetizationType: Types.MonetizationType;
						availableTo?: any | null;
						dateCreated?: any | null;
						newElementCount?: number | null;
						mediaDealId?: number | null;
						package: {
							__typename?: 'Package';
							id: string;
							icon: string;
							packageId: number;
							clearName: string;
							shortName: string;
							technicalName: string;
							iconWide: string;
							hasRectangularIcon: boolean;
						};
					} | null;
					availableTo: Array<{
						__typename?: 'AvailableTo';
						availableCountDown: number;
						availableToDate: any;
						package: { __typename?: 'Package'; id: string; shortName: string };
					}>;
					fallBackClips: {
						__typename?: 'ShowContent';
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
					};
					content: {
						__typename?: 'ShowContent';
						originalTitle: string;
						ageCertification?: string | null;
						productionCountries: Array<any>;
						fullPath: string;
						posterUrl?: string | null;
						runtime?: number | null;
						isReleased: boolean;
						shortDescription?: string | null;
						title: string;
						originalReleaseYear?: number | null;
						originalReleaseDate?: any | null;
						fullPosterUrl?: string | null;
						subgenres: Array<{
							__typename?: 'GenericTitleList';
							content: {
								__typename?: 'GenericTitleListContent';
								shortName?: string | null;
								name: string;
								url?: { __typename?: 'Url'; fullPath: string } | null;
							};
						}>;
						editorialContent?: { __typename?: 'EditorialContent'; synopsis?: string | null } | null;
						directors: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
						credits: Array<{
							__typename: 'Credit';
							role: Types.CreditRole;
							name: string;
							characterName?: string | null;
							personId: number;
							portraitUrl?: string | null;
							profilePath?: string | null;
						}>;
						interactions: {
							__typename?: 'InteractionAttributes';
							dislikelistAdditions: number;
							likelistAdditions: number;
							votesNumber: number;
						};
						tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
						backdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						fullBackdrops: Array<{ __typename?: 'Backdrop'; backdropUrl: string }>;
						clips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						videobusterClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						dailymotionClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						justwatchtvClips: Array<{
							__typename?: 'Clip';
							sourceUrl: string;
							externalId: string;
							provider: Types.ClipProvider;
							name: string;
							sources: {
								__typename?: 'Sources';
								dynamicManifest?: { __typename?: 'Source'; fileGroupId: number } | null;
							};
						}>;
						externalIds: { __typename?: 'ExternalIds'; imdbId?: string | null; wikidataId?: string | null };
						externalURLs: { __typename?: 'ExternalURLs'; wikipediaURL?: string | null };
						scoring: {
							__typename?: 'Scoring';
							imdbScore?: number | null;
							imdbVotes?: number | null;
							tmdbPopularity?: number | null;
							tmdbScore?: number | null;
							jwRating?: number | null;
							tomatoMeter?: number | null;
							certifiedFresh?: boolean | null;
						};
						upcomingReleases: Array<{
							__typename?: 'UpcomingRelease';
							releaseCountDown?: number | null;
							releaseDate?: any | null;
							releaseType: Types.ReleaseType;
							label: Types.UpcomingReleaseLabel;
							package?: {
								__typename?: 'Package';
								id: string;
								packageId: number;
								shortName: string;
								clearName: string;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								iconWide: string;
								hasRectangularIcon: boolean;
								planOffers: Array<{
									__typename?: 'PackagePlanOffer';
									retailPrice?: string | null;
									durationDays?: number | null;
									presentationType?: Types.PresentationType | null;
									isTrial?: boolean | null;
									retailPriceValue?: number | null;
									currency?: string | null;
								}>;
							} | null;
						}>;
						genres: Array<{ __typename?: 'Genre'; shortName: string; translation: string }>;
						textRecommendations?: Array<{
							__typename: 'TextRecommendation';
							id: string;
							headline?: string | null;
							body: string;
							bodyHTML: string;
							originalHeadline?: string | null;
							originalBody?: string | null;
							originalBodyHTML?: string | null;
							watchIf?: Array<string> | null;
							skipIf?: Array<string> | null;
							customProfileType?: string | null;
							watchedAt: any;
							likeCount: number;
							likedByUser: boolean;
							ownedByUser: boolean;
							updatedAt: any;
							tags?: Array<{ __typename?: 'Tag'; technicalName: string; translatedName: string }> | null;
							watchedOn?: {
								__typename?: 'Package';
								clearName: string;
								id: string;
								shortName: string;
								technicalName: string;
								packageId: number;
								selected: boolean;
								monetizationTypes: Array<Types.MonetizationType>;
								icon: string;
								isVisibleFilterBar: boolean;
								addonParent?: { __typename?: 'Package'; id: string } | null;
							} | null;
							profile: {
								__typename: 'Profile';
								displayName: string;
								firstName: string;
								lastName: string;
								location?: string | null;
								country: any;
								bio?: string | null;
								avatarUrl?: string | null;
								isComplete: boolean;
								ownedByUser: boolean;
								profileUrl: string;
								profileType: Types.ProfileType;
								contentPersonId?: string | null;
								textRecommendationsCount: number;
								id: string;
								externalUrls?: Array<{
									__typename?: 'ProfileSpecificLink';
									type: Types.ProfileSpecificLinkType;
									name?: string | null;
									url: string;
								}> | null;
							};
							title?:
								| {
										__typename: 'Movie';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'MovieContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Season';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'SeasonContent';
											seasonNumber: number;
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										show: {
											__typename: 'Show';
											id: string;
											objectId: number;
											objectType: Types.ObjectType;
											content: { __typename?: 'ShowContent'; title: string; fullPath: string };
											watchNowOffer?: {
												__typename: 'Offer';
												id: string;
												standardWebURL?: string | null;
												preAffiliatedStandardWebURL?: string | null;
												streamUrl?: string | null;
												streamUrlExternalPlayer?: string | null;
												retailPrice?: string | null;
												retailPriceValue?: number | null;
												lastChangeRetailPriceValue?: number | null;
												currency?: string | null;
												presentationType: Types.PresentationType;
												monetizationType: Types.MonetizationType;
												availableTo?: any | null;
												dateCreated?: any | null;
												newElementCount?: number | null;
												mediaDealId?: number | null;
												package: {
													__typename?: 'Package';
													id: string;
													icon: string;
													packageId: number;
													clearName: string;
													shortName: string;
													technicalName: string;
													iconWide: string;
													hasRectangularIcon: boolean;
												};
											} | null;
											watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
											seenState: { __typename?: 'ShowSeenState'; progress: number };
											tvShowTrackingEntry?: {
												__typename?: 'TitleListEntry';
												createdAt: any;
											} | null;
											customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  }
								| {
										__typename: 'Show';
										id: string;
										objectId: number;
										objectType: Types.ObjectType;
										content: {
											__typename?: 'ShowContent';
											title: string;
											posterUrl?: string | null;
											fullPath: string;
											upcomingReleases: Array<{
												__typename?: 'UpcomingRelease';
												releaseDate?: any | null;
												releaseCountDown?: number | null;
											}>;
											scoring: {
												__typename?: 'Scoring';
												imdbScore?: number | null;
												imdbVotes?: number | null;
												tmdbPopularity?: number | null;
												tmdbScore?: number | null;
												jwRating?: number | null;
												tomatoMeter?: number | null;
												certifiedFresh?: boolean | null;
											};
										};
										watchNowOffer?: {
											__typename: 'Offer';
											id: string;
											standardWebURL?: string | null;
											preAffiliatedStandardWebURL?: string | null;
											streamUrl?: string | null;
											streamUrlExternalPlayer?: string | null;
											retailPrice?: string | null;
											retailPriceValue?: number | null;
											lastChangeRetailPriceValue?: number | null;
											currency?: string | null;
											presentationType: Types.PresentationType;
											monetizationType: Types.MonetizationType;
											availableTo?: any | null;
											dateCreated?: any | null;
											newElementCount?: number | null;
											mediaDealId?: number | null;
											package: {
												__typename?: 'Package';
												id: string;
												icon: string;
												packageId: number;
												clearName: string;
												shortName: string;
												technicalName: string;
												iconWide: string;
												hasRectangularIcon: boolean;
											};
										} | null;
										availableTo: Array<{
											__typename?: 'AvailableTo';
											availableToDate: any;
											availableCountDown: number;
										}>;
										watchlistEntryV2?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										customlistEntries: Array<{ __typename?: 'TitleListEntry'; createdAt: any }>;
										seenState: { __typename?: 'ShowSeenState'; progress: number };
										tvShowTrackingEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
										likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
								  };
							video?: {
								__typename?: 'Clip';
								externalId: string;
								name: string;
								provider: Types.ClipProvider;
								publishedAt: any;
								sourceUrl: string;
								streamUrl?: string | null;
							} | null;
						}> | null;
					};
					popularityRank: {
						__typename?: 'PopularityRank';
						rank: number;
						trend: Types.ModuleContentTitleTrend;
						trendDifference: number;
					};
					streamingCharts: {
						__typename?: 'StreamingChartsConnection';
						edges?: Array<{
							__typename?: 'StreamingChartsTitlesEdge';
							streamingChartInfo?: {
								__typename?: 'StreamingChartInfo';
								rank: number;
								trend: Types.ModuleContentTitleTrend;
								trendDifference: number;
								updatedAt?: any | null;
								daysInTop10: number;
								daysInTop100: number;
								daysInTop1000: number;
								daysInTop3: number;
								topRank: number;
							} | null;
						}> | null;
					};
					likelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					dislikelistEntry?: { __typename?: 'TitleListEntry'; createdAt: any } | null;
					titleModules: Array<{
						__typename?: 'Module';
						fomoScore: number;
						content?:
							| { __typename?: 'ModuleContentSQTV' }
							| { __typename?: 'ModuleContentSports' }
							| {
									__typename?: 'ModuleContentStreamingCharts';
									Titles: Array<{
										__typename?: 'ModuleStreamingChartEdges';
										fullPath: string;
										jwEntityID: string;
										posterUrl: string;
										title: string;
										showTitle?: string | null;
										seasonNumber?: number | null;
										rankInfo: {
											__typename?: 'StreamingChartInfo';
											rank: number;
											trend: Types.ModuleContentTitleTrend;
											trendDifference: number;
											updatedAt?: any | null;
											daysInTop10: number;
											daysInTop100: number;
											daysInTop1000: number;
											daysInTop3: number;
											topRank: number;
										};
									}>;
							  }
							| { __typename?: 'ModuleContentTextRecommendation' }
							| { __typename?: 'ModuleContentTextRecommendations' }
							| {
									__typename?: 'ModuleContentTitles';
									titles: Array<{
										__typename?: 'ModuleContentTitleEdge';
										node:
											| {
													__typename: 'Movie';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenlistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													content: {
														__typename?: 'MovieContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  }
											| {
													__typename: 'Season';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													content: {
														__typename?: 'SeasonContent';
														seasonNumber: number;
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
													show: {
														__typename: 'Show';
														id: string;
														objectId: number;
														objectType: Types.ObjectType;
														content: { __typename?: 'ShowContent'; title: string };
													};
											  }
											| {
													__typename: 'Show';
													id: string;
													objectId: number;
													objectType: Types.ObjectType;
													watchlistEntryV2?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													likelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													dislikelistEntry?: {
														__typename?: 'TitleListEntry';
														createdAt: any;
													} | null;
													seenState: {
														__typename?: 'ShowSeenState';
														progress: number;
														seenEpisodeCount: number;
													};
													content: {
														__typename?: 'ShowContent';
														title: string;
														posterUrl?: string | null;
														fullPath: string;
														genres: Array<{ __typename?: 'Genre'; translation: string }>;
														backdrops: Array<{
															__typename?: 'Backdrop';
															backdropUrl: string;
														}>;
														scoring: {
															__typename?: 'Scoring';
															imdbVotes?: number | null;
															imdbScore?: number | null;
															tomatoMeter?: number | null;
															certifiedFresh?: boolean | null;
															jwRating?: number | null;
														};
														interactions: {
															__typename?: 'InteractionAttributes';
															votesNumber: number;
														};
													};
											  };
									}>;
							  }
							| { __typename?: 'ModuleContentTitlesArticle' }
							| { __typename?: 'ModuleContentTitlesPerPackage' }
							| { __typename?: 'ModuleContentTitlesRelatedToTitle' }
							| { __typename?: 'ModuleContentVODTitles' }
							| null;
						template: {
							__typename?: 'ModuleTemplate';
							anchor?: string | null;
							contentType: Types.ModuleContentType;
							technicalName: string;
						};
					} | null>;
			  }
			| { __typename?: 'SingleStepSportEvent' }
			| { __typename?: 'SportCompetitionV2' }
			| { __typename?: 'SportCompetitorV2' }
			| { __typename?: 'SportMatch' }
			| { __typename?: 'Url' }
			| { __typename?: 'UserProviderSubscription' };
	};
};

export const GetUrlTitleDetailsDocument = gql`
	query GetUrlTitleDetails(
		$fullPath: String!
		$site: String
		$country: Country!
		$language: Language!
		$episodeMaxLimit: Int
		$platform: Platform! = WEB
		$allowSponsoredRecommendations: SponsoredRecommendationsInput
		$format: ImageFormat
		$backdropProfile: BackdropProfile
		$excludeTextRecommendationTitle: Boolean = true
		$streamingChartsFilter: StreamingChartsFilter
		$first: Int! = 10
		$fallbackToForeignOffers: Boolean = true
		$excludePackages: [String!] = []
	) {
		urlV2(fullPath: $fullPath, site: $site) {
			id
			urlID
			inLists
			metaDescription
			metaKeywords
			metaRobots
			metaTitle
			heading1
			heading2
			htmlContent
			htmlContentJson
			node {
				...TitleDetails
				...TitleDetailModules
			}
		}
	}
	${TitleDetailsFragmentDoc}
	${TitleDetailModulesFragmentDoc}
`;
